import { useEffect, useRef, useState } from "react";
import {
  Button,
  Container,
  Icon,
  InputCheckbox,
  InputDate,
  InputDropdown,
  InputField,
  InputPhoneDropdown,
  InputRadio,
  InputTextarea,
  Notifications,
  Text,
} from "@jds/core";
import AvatarUpload from "./avatarUpload/AvatarUpload";
import {
  validateEmail,
  validateNameInput,
  validateNameWithOnlyLetters,
  validatePhoneNumber,
  validateTextInput,
} from "../../../util/validation";
import useInput from "../../../hooks/use-input";
import useApiHttp from "../../../hooks/use-http";
import { useParams } from "react-router-dom";
import PageLoader from "../Loader/PageLoader";
import ExcelFile from "../../../assets/excel/Sample_Excel.xlsx";
import {
  countryPhoneCodes,
  downloadFile,
  excelValidationCheck,
  validateFileSignature,
} from "../../../util/helper";
import { Box } from "@mui/material";
export default function InviteGuestForm(props) {
  const role = props?.role || "GUEST";
  const bulkUploadRef = useRef(null);
  const { sendRequest: addGuest, isLoading: guestAdding } = useApiHttp();
  const { sendRequest: bulkUpload, isLoading: bulkUploading } = useApiHttp();

  const { sendRequest: getFaceCount, isLoading: isGetFaceCounting } =
    useApiHttp();
  const [selectedCountry, setSelectedCountry] = useState(0);
  const [imgChange, setImgChange] = useState(false);
  const [customFields, setCustomFields] = useState({});
  const [formValueForCustom, setFormValueForCustom] = useState({});
  const { id: eventId } = useParams();

  const countryCodeItems = countryPhoneCodes.map((obj) => ({
    label: obj?.dial_code,
    value: obj?.dial_code,
  }));

  const {
    value: profileImage,
    isValid: isValidProfileImage,
    hasError: profileImageError,
    valueChangeHandler: profileImageChangeHandler,
    inputBlurHandler: profileImageBlurHandler,
    reset: resetProfileImage,
  } = useInput((data) => {
    return typeof data === "object" ? true : false;
  });

  const {
    value: firstName,
    isValid: isValidFirstName,
    hasError: firstNameError,
    valueChangeHandler: firstNameChangeHandler,
    inputBlurHandler: firstNameBlurHandler,
    reset: resetFirstName,
  } = useInput((data) => {
    if (typeof data !== "string") return false;
    if (data.length > 20) return false;
    const pattern = /^[a-zA-Z]+$/; // only letters no numbers, spaces or special chars
    return pattern.test(data.trim());
  });
  const {
    value: lastName,
    isValid: isValidlastName,
    hasError: lastNameError,
    valueChangeHandler: lastNameChangeHandler,
    inputBlurHandler: lastNameBlurHandler,
    reset: resetLastName,
  } = useInput((data) => {
    if (typeof data !== "string") return false;
    if (data.length > 20) return false;
    const pattern = /^[a-zA-Z]+$/; // only letters no numbers, spaces or special chars
    return pattern.test(data.trim());
  });
  const {
    value: phoneNumber,
    isValid: isValidPhoneNumber,
    hasError: phoneNumberError,
    valueChangeHandler: phoneNumberChangeHandler,
    inputBlurHandler: phoneNumberBlurHandler,
    reset: resetPhoneNumber,
  } = useInput(validatePhoneNumber);
  const {
    value: emailAddress,
    isValid: isValidEmailAddress,
    hasError: emailAddressError,
    valueChangeHandler: emailAddressChangeHandler,
    inputBlurHandler: emailAddressBlurHandler,
    isTouched: emailIsTouched,
    reset: resetEmailAddress,
  } = useInput(validateEmail);

  // const customFieldsValidtion = Object.entries(customFields)?.every(
  //   ([key, item]) => {
  //     if (item.required) {
  //       return (
  //         formValueForCustom[item.id] !== undefined &&
  //         formValueForCustom[item.id] !== "" &&
  //         formValueForCustom[item.id] !== false
  //       );
  //     }
  //     return true;
  //   }
  // );
  const isValidForm =
    !isValidFirstName ||
    !isValidlastName ||
    !isValidPhoneNumber ||
    !isValidEmailAddress;
  const handleSubmit = () => {
    const countryCode = countryCodeItems.filter((items, index) => {
      if (index == selectedCountry) {
        return items;
      }
    })[0]?.value;
    const formData = new FormData();
    formData.append("eventid", eventId);
    formData.append("firstName", firstName.trim());
    formData.append("lastName", lastName.trim());
    formData.append("countryCode", countryCode);
    formData.append("phoneNumber", phoneNumber);
    formData.append("email", emailAddress.trim() || "");
    formData.append("profilePicture", imgChange ? profileImage : null);
    formData.append("customField", JSON.stringify(formValueForCustom));
    formData.append("role", role);
    if (imgChange) {
      const faceCheck = new FormData();
      faceCheck.append("uploadFile", profileImage);
      getFaceCount(
        {
          base: "MEDIA",
          url: `face/get-face-count`,
          method: "POST",
          body: faceCheck,
          formData: true,
        },
        null,
        (data) => {
          addGuest(
            {
              url: `event-attendee/add-attendee`,
              method: "POST",
              body: formData,
              formData: true,
            },
            null,
            (data) => {
              Notifications.toast.success({
                id: "add-user",
                title: data?.message,
              });
              // props.closeModal();
              props?.onSuccess();
            },
            (err, data) => {
              Notifications.toast.error({
                id: "add-user",
                title: data?.message,
              });
            },
          );
        },
        (err, data) => {
          Notifications.toast.error({
            id: "get-face-count-error",
            title: data?.message,
          });
        },
      );
    } else {
      addGuest(
        {
          url: `event-attendee/add-attendee`,
          method: "POST",
          body: formData,
          formData: true,
        },
        null,
        (data) => {
          Notifications.toast.success({
            id: "add-user",
            title: data?.message,
          });
          // props.closeModal();
          props?.onSuccess();
        },
        (err, data) => {
          Notifications.toast.error({
            id: "add-user",
            title: data?.message,
          });
        },
      );
    }
  };

  const handleBulkUpload = (file) => {
    const formData = new FormData();
    formData.append("eventId", eventId);
    formData.append("file", file);
    formData.append("role", role);
    bulkUpload(
      {
        url: `event-attendee/upload`,
        method: "POST",
        body: formData,
        formData: true,
      },
      null,
      (data) => {
        Notifications.toast.success({
          id: "bulk-add-user",
          title: data?.message,
        });
        // props.closeModal();
        props?.onSuccess();
      },
    );
  };

  // const countryCodeItems = [
  //   {
  //     label: "+91",
  //     prefix: <Icon ic={"IcAdd"} />,
  //     value: "+91",
  //   },
  //   {
  //     label: "+88",
  //     prefix: <Icon ic={"IcAdd"} />,
  //     value: "+88",
  //   },
  //   {
  //     label: "+78",
  //     prefix: <Icon ic={"IcAdd"} />,
  //     value: "+78",
  //   },
  // ];

  const inputFieldsRender = (key, item) => {
    switch (item.type) {
      case "text":
        return (
          <InputField
            label={`${item.questionName} ${item.required ? "*" : ""}`}
            onChange={(e) => {
              setFormValueForCustom((pre) => {
                return { ...pre, [key]: e.target.value };
              });
            }}
          />
        );
      case "dropdown":
        return (
          <InputDropdown
            label={`${item.questionName} ${item.required ? "*" : ""}`}
            items={item.options?.map((val) => {
              return {
                label: val,
                value: val,
              };
            })}
            onSelect={(i, value) => {
              setFormValueForCustom((pre) => {
                return { ...pre, [key]: value };
              });
            }}
          />
        );

      case "date":
        return (
          <InputDate
            label={`${item.questionName} ${item.required ? "*" : ""}`}
            onChange={(value) => {
              setFormValueForCustom((pre) => {
                return { ...pre, [key]: value };
              });
            }}
          />
        );
      case "consent":
        return (
          <InputCheckbox
            label={
              <Text
                text={`${item.questionName} ${item.required ? "*" : ""}`}
                appearance="body-xs"
                color="primary_grey_80"
              />
            }
            size="small"
            onChange={(e) => {
              setFormValueForCustom((pre) => {
                return { ...pre, [key]: e.target.checked };
              });
            }}
            checked={formValueForCustom[key]}
          />
        );

      case "checkbox":
        return (
          <div style={{ width: "100%" }}>
            <Container direction="column" fullWidth>
              <Text
                text={`${item.questionName} ${item.required ? "*" : ""}`}
                appearance="body-xs"
                color="primary_grey_80"
              />
              <Container
                gap={40}
                fullWidth
                style={{
                  flexWrap: "wrap",
                  marginTop: "10px",
                }}
              >
                <Container fullWidth direction="column" gap={8}>
                  {item.options?.map((val) => (
                    <InputCheckbox
                      label={
                        <Text
                          text={`${val}`}
                          appearance="body-xs"
                          color="primary_grey_80"
                        />
                      }
                      size="small"
                      value={val}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setFormValueForCustom((pre) => {
                            const formValue = { ...pre };
                            const checkBoxValue = pre[key] || [];
                            formValue[key] = [...checkBoxValue, e.target.value];
                            return formValue;
                          });
                        } else {
                          setFormValueForCustom((pre) => {
                            const formValue = { ...pre };
                            const checkBoxValue = pre[key] || [];
                            const filterData = checkBoxValue.filter((item) => {
                              if (item !== e.target.value) {
                                return item;
                              }
                            });
                            formValue[key] = filterData;
                            return formValue;
                          });
                        }
                      }}
                      checked={
                        formValueForCustom[key]?.filter((item) => item == val)
                          .length
                          ? true
                          : false
                      }
                    />
                  ))}
                </Container>
              </Container>
            </Container>
          </div>
        );

      case "paragraph":
        return (
          <>
            <InputTextarea
              label={`${item.questionName} ${item.required ? "*" : ""}`}
              rows={2}
              onChange={(e) => {
                setFormValueForCustom((pre) => {
                  return { ...pre, [key]: e.target.value };
                });
              }}
            />
          </>
        );
      case "radio":
        return (
          <>
            <Container direction="column" gap={8} fullWidth>
              <Text
                text={`${item.questionName} ${item.required ? "*" : ""}`}
                appearance="body-xs"
                color="primary_grey_80"
              />
              <Container gap={8} fullWidth>
                {item.options?.map((val) => (
                  <InputRadio
                    label={val}
                    suffix="ic_profile"
                    prefix="ic_profile"
                    size="small"
                    checked={formValueForCustom[key] === val ? true : false}
                    onClick={(e) => {
                      setFormValueForCustom((pre) => {
                        return { ...pre, [key]: e.target.value };
                      });
                    }}
                    value={val}
                  />
                ))}{" "}
              </Container>
            </Container>
          </>
        );

      default:
        return <></>;
    }
  };
  // console.log("hello1234last", firstName);
  useEffect(() => {
    setCustomFields({ ...props?.customFields });
  }, []);
  return (
    <>
      <div className="column-form full-width">
        <AvatarUpload
          accept=".png ,.jpg ,.jpeg"
          fileValue={(value) => {
            profileImageChangeHandler({ target: { value } });
            setImgChange(true);
          }}
          error={profileImageError}
          errorText={"Invalid Image"}
          id={"add-guest"}
        />
        <InputField
          label="First Name *"
          value={firstName}
          name="firstName"
          onChange={(e) => {
            firstNameChangeHandler(e, e.target.value);
          }}
          onBlur={firstNameBlurHandler}
          state={firstNameError ? "error" : ""}
          stateText={
            firstName?.length > 20
              ? "The First name length can't exceed 20 characters"
              : firstName?.length == 0
                ? "The First name can't be blank"
                : "The First name can't contain spaces, special characters and numbers"
          }
        />
        <InputField
          label="Last Name *"
          value={lastName}
          name="lastName"
          onChange={(e) => {
            lastNameChangeHandler(e, e.target.value);
          }}
          onBlur={lastNameBlurHandler}
          state={lastNameError ? "error" : ""}
          stateText={
            lastName?.length > 20
              ? "The Last name length can't exceed 20 characters"
              : lastName?.length == 0
                ? "The Last name can't be blank"
                : "The Last name can't contain spaces, special characters and numbers"
          }
        />

        <InputField
          label="Phone Number *"
          value={phoneNumber}
          name="phoneNumber"
          onChange={(e) => {
            if (e.target.value.length <= 10) {
              phoneNumberChangeHandler(e);
            }
          }}
          onBlur={phoneNumberBlurHandler}
          state={phoneNumberError ? "error" : ""}
          stateText="Please enter valid phone number!"
          type="number"
          prefix={
            <InputPhoneDropdown
              selectedIndex={selectedCountry}
              items={countryCodeItems}
              onSelect={(idx) => {
                setSelectedCountry(idx);
                // action("country code selected index:")(idx);
              }}
              disabled
            />
          }
        />

        <InputField
          label="Email *"
          value={emailAddress}
          name="emailAddress"
          type={"email"}
          onChange={emailAddressChangeHandler}
          onBlur={emailAddressBlurHandler}
          state={emailAddressError ? "error" : ""}
          stateText="Please enter valid email id!"
        />

        {/* {role == "GUEST" &&
          Object.entries(customFields).map(([key, value]) =>
            inputFieldsRender(key, value)
          )} */}
        <Container
          fullWidth
          direction="column"
          gap={24}
          style={{ marginTop: "12px" }}
        >
          <input
            ref={bulkUploadRef}
            type="file"
            accept=".xlsx"
            onChange={(e) => {
              const file = e.target.files[0];
              if (excelValidationCheck(e)) {
                validateFileSignature(file, {
                  xlsx: ["504b0304"],
                })
                  .then((isValid) => {
                    if (isValid) {
                      handleBulkUpload(file);
                    } else {
                      Notifications.toast.error({
                        id: "user-bulk",
                        title: "Please upload .xlsx format file",
                      });
                    }
                  })
                  .catch((error) => {
                    Notifications.toast.error({
                      id: "user-bulk",
                      title: "Please upload .xlsx format file",
                    });
                  });
              } else {
                Notifications.toast.error({
                  id: "user-bulk",
                  title: "Please upload .xlsx format file",
                });
              }
              bulkUploadRef.current.value = null;
            }}
          />
          <Container fullWidth>
            <Container fullWidth>
              <Button
                fullWidth
                disabled={isValidForm}
                type="submit"
                label="Add"
                size="large"
                onClick={handleSubmit}
              />
            </Container>
            <Container fullWidth>
              <Button
                fullWidth
                type="button"
                label="Bulk Upload"
                size="large"
                kind="secondary"
                onClick={() => {
                  bulkUploadRef.current.click();
                }}
              />
            </Container>
          </Container>
        </Container>
        <div>
          <span
            style={{
              fontFamily: "var(--font-families-body-s)",
              color: "var(--color-primary-grey-80)",
            }}
          >
            * Supported bulk upload file should be in .xlsx format. Please
            upload excel file in this{" "}
          </span>
          <span style={{ display: "inline-block" }}>
            <span
              onClick={() => {
                downloadFile(ExcelFile, "Sample_Excel");
              }}
              style={{
                fontFamily: "var(--font-families-body-s)",
                color: "var(--color-primary-50)",
                display: "flex",
              }}
            >
              <b>
                <u>sample format</u>
              </b>

              <Box
                sx={
                  {
                    // "--color-primary-50": "blue",
                  }
                }
              >
                <Icon ic={"IcFileRequest"} color="primary" />
              </Box>
            </span>
          </span>
        </div>
      </div>
      {(guestAdding || bulkUploading) && (
        <PageLoader open={guestAdding || bulkUploading} />
      )}
    </>
  );
}
